import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MainApp from "./MainApp"; // rename your current app logic to MainApp.jsx
import LandingPage from "./LandingPage";
import { ApolloClient, InMemoryCache, ApolloProvider } from "@apollo/client";

const client = new ApolloClient({
  uri:  "https://hq4izjjs8b.execute-api.us-east-1.amazonaws.com/graphql", //"http://localhost:8080/graphql", //process.env.REACT_APP_GRAPHQL_ENDPOINT,
  cache: new InMemoryCache(),
});


export default function App() {
  return (
    <ApolloProvider client={client}>
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/launch" element={<MainApp />} />
      </Routes>
    </Router>
    </ApolloProvider>
  );
}
